query GetHifoAutofill($name: String, $charityId: ID) {
  hifoAutofill(name: $name, charityId: $charityId) {
    name
    website
    primaryCauseArea
    worldview
    grantRestrictions
    expiryDate
    lastEvaluated
    rating
    roomForFunding {
      currency
      minorUnit
    }
    isResearchInternal
    evaluationTemplateLink
    operatingAreas
    researcherRelationship {
      id
      name
    }
    minDonationAmount {
      currency
      minorUnit
    }
    audience
    hifoType
    charity {
      id
    }
  }
}
